import { Name as EntityName } from '../../../../core/entity';

const SELECTOR_PREFIX = `${EntityName.SELECTOR_PREFIX}FORM:`;
export const FORM_VALIDATION = `${SELECTOR_PREFIX}form_validation`;
export const FORM_FIELD_VALUE = `${SELECTOR_PREFIX}form_field_value`;
export const FORM_VALUE = `${SELECTOR_PREFIX}form_value`;
